(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["giftexpress-sale-countdown"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('gex-sale-countdown')) return;

  const dayMilliseconds = 86400000;
  const previewDuration = 10 * dayMilliseconds;

  function parseCycleStart(value) {
    const text = String(value || '').trim();
    const match = text.match(
      /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2})(?:\.\d{1,3})?)?(Z|[+-]\d{2}:\d{2})$/i
    );
    if (!match) return null;

    const [, year, month, day, hour, minute, second = '0', zone] = match;
    const calendar = new Date(0);
    calendar.setUTCFullYear(Number(year), Number(month), 0);
    const daysInMonth = calendar.getUTCDate();
    if (
      Number(month) < 1 || Number(month) > 12 ||
      Number(day) < 1 || Number(day) > daysInMonth ||
      Number(hour) > 23 || Number(minute) > 59 || Number(second) > 59 ||
      (zone.toUpperCase() !== 'Z' &&
        (Number(zone.slice(1, 3)) > 23 || Number(zone.slice(4)) > 59))
    ) return null;

    const timestamp = Date.parse(text);
    return Number.isFinite(timestamp) ? timestamp : null;
  }

  function parseCyclePeriod(value) {
    const text = String(value ?? '10').trim();
    if (!/^\d+$/.test(text)) return null;
    const period = Number(text) * dayMilliseconds;
    return Number.isSafeInteger(period) && period > 0 ? period : null;
  }

  class GiftExpressSaleCountdown extends HTMLElement {
    static get observedAttributes() {
      return ['data-cycle-start', 'data-cycle-days', 'data-preview', 'data-invalid-message', 'data-upcoming-message'];
    }

    constructor() {
      super();
      this._countdownInterval = null;
      this._previewDeadline = null;
      this._refreshOnWake = () => this._restartCountdown();
    }

    connectedCallback() {
      this.setAttribute('aria-live', 'off');
      document.addEventListener('visibilitychange', this._refreshOnWake);
      window.addEventListener('pageshow', this._refreshOnWake);
      this._restartCountdown();
    }

    disconnectedCallback() {
      this._stopCountdown();
      document.removeEventListener('visibilitychange', this._refreshOnWake);
      window.removeEventListener('pageshow', this._refreshOnWake);
    }

    attributeChangedCallback() {
      if (this.isConnected) this._restartCountdown();
    }

    _stopCountdown() {
      if (this._countdownInterval !== null) {
        clearInterval(this._countdownInterval);
        this._countdownInterval = null;
      }
    }

    _restartCountdown() {
      this._stopCountdown();
      if (!this.isConnected || !this._renderCountdown()) return;
      this._countdownInterval = setInterval(() => {
        if (!this._renderCountdown()) this._stopCountdown();
      }, 1000);
    }

    _renderCountdown() {
      const preview = this.getAttribute('data-preview') === 'true';
      const now = Date.now();
      const enteredStart = (this.getAttribute('data-cycle-start') || '').trim();
      const anchor = parseCycleStart(enteredStart);
      const period = parseCyclePeriod(this.getAttribute('data-cycle-days'));
      const invalid = anchor === null || period === null;
      const upcoming = !invalid && now < anchor;
      const previewNote = this.querySelector('[data-countdown-preview]');
      const status = this.querySelector('[data-countdown-status]');

      this.hidden = !preview && (invalid || upcoming);
      if (previewNote) previewNote.hidden = !(preview && invalid && !enteredStart && period !== null);
      if (status) {
        const message = preview && (upcoming || (invalid && (enteredStart || period === null)))
          ? this.getAttribute(upcoming ? 'data-upcoming-message' : 'data-invalid-message') || ''
          : '';
        status.textContent = message;
        status.hidden = !message;
      }

      if (invalid && !preview) return false;

      let remaining;
      if (invalid) {
        if (this._previewDeadline === null) this._previewDeadline = now + previewDuration;
        remaining = Math.max(0, Math.ceil((this._previewDeadline - now) / 1000));
      } else if (upcoming) {
        remaining = 0;
      } else {
        const completedCycles = Math.floor((now - anchor) / period);
        const nextDeadline = anchor + (completedCycles + 1) * period;
        remaining = Math.max(0, Math.ceil((nextDeadline - now) / 1000));
      }

      const units = {
        days: Math.floor(remaining / 86400),
        hours: Math.floor((remaining % 86400) / 3600),
        minutes: Math.floor((remaining % 3600) / 60),
        seconds: remaining % 60,
      };
      for (const [unit, value] of Object.entries(units)) {
        const output = this.querySelector(`[data-countdown-unit="${unit}"]`);
        if (output) output.textContent = String(value).padStart(2, '0');
      }

      return !invalid || remaining > 0;
    }
  }

  customElements.define('gex-sale-countdown', GiftExpressSaleCountdown);
})();
  } catch(e) { console.error(e); }
})();

})();
